import { SVGProps, Ref, forwardRef } from 'react';

export const FolderArrowRightFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.37 9c0-5.25 1.75-7 7-7h3.13l.8 2h3.33c4.51 0 6.438 1.292 6.89 4.986-1.308-.423-2.72-.486-4.084-.486H5.564c-1.402 0-2.856.064-4.194.522zm17.066 1.3c1.928 0 3.296.196 4.194.675 1.472.786 1.675 2.333 1 5.025-1.087 4.332-2.807 6-7.9 6H8.27c-5.094 0-6.814-1.668-7.9-6-.676-2.692-.473-4.24 1-5.025.897-.479 2.265-.675 4.194-.675zM12.989 20l4.01-4-4.01-4-1.273 1.27 1.838 1.832H7v1.795h6.554l-1.838 1.834z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
FolderArrowRightFilledSize24Glyph.displayName = 'FolderArrowRightFilledSize24Glyph';
